{
  "PAGINATION_FOOTER": {
    "SHOWING": "Zobrazeno {startItem} - {endItem} z {totalItems} položek",
    "CURRENT_PAGE_INFO": "Strana {currentPage} z {totalPages}"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Vyberte možnost...",
    "EMPTY_SEARCH_RESULTS": "Pro hledaný výraz `{searchTerm}` nebyly nalezeny žádné položky",
    "EMPTY_STATE": "Žádné výsledky.",
    "SEARCH_PLACEHOLDER": "Hledat...",
    "MORE": "+{count} dalších"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Hledat...",
    "EMPTY_STATE": "Žádné výsledky.",
    "SEARCHING": "Hledá se..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Zrušit",
      "CONFIRM": "Potvrdit"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Vyhledat zemi",
    "ERROR": "Telefonní číslo musí být prázdné nebo ve formátu E.164",
    "DIAL_CODE_ERROR": "Vyberte prosím předvolbu ze seznamu"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Autor není k dispozici"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Navigační cesta"
  },
  "SWITCH": {
    "TOGGLE": "Přepínač"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Zjistit více",
    "WATCH_VIDEO": "Přehrát video"
  },
  "COLOR_GRID": {
    "SHOW_COLORS": "Zobrazit barvy",
    "HIDE_COLORS": "Skrýt barvy"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minuty",
    "HOURS": "Hodiny",
    "DAYS": "Dny",
    "PLACEHOLDER": "Zadejte dobu"
  }
}
